import { render } from "./layoutLogin.vue?vue&type=template&id=451aa5d1&scoped=true"
import script from "./layoutLogin.vue?vue&type=script&lang=js"
export * from "./layoutLogin.vue?vue&type=script&lang=js"

import "./layoutLogin.vue?vue&type=style&index=0&id=451aa5d1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451aa5d1"]])

export default __exports__